import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/export-purchase-transaction.request.dto';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ReconciliationTransactionService } from '@core/services/entities/reconciliation-transaction.service';
import { PurchaseTransactionResponseDto } from '@domain/purchase-transaction/dtos/purchase-transaction.response.dto';
import { ListPurchaseTransactionRequestDto } from '@domain/purchase-transaction/dtos/list-purchase-transaction.request.dto';
import { SummaryReconciliationTransactionRequestDto } from '@domain/reconciliation-transaction/dtos/summary-reconciliation-transaction.request.dto';
import { SummaryReconciliationTransactionResponseDto } from '@domain/reconciliation-transaction/dtos/summary-reconciliation-transaction.response.dto';
import { ReconciliationTransactionRepository } from './reconciliation-transaction.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReconciliationTransactionRepositoryService
  implements ReconciliationTransactionRepository
{
  constructor(private reconciliationTransactionService: ReconciliationTransactionService) {}

  show(
    request: RefId,
  ): Observable<ApiResponse<PurchaseTransactionResponseDto>> {
    return this.reconciliationTransactionService.show(request);
  }

  list(
    request: ListPurchaseTransactionRequestDto,
  ): Observable<ApiResponse<PageableResponse<PurchaseTransactionResponseDto>>> {
    return this.reconciliationTransactionService.list(request);
  }

  summary(
    request: SummaryReconciliationTransactionRequestDto,
  ): Observable<ApiResponse<SummaryReconciliationTransactionResponseDto>> {
    return this.reconciliationTransactionService.summary(request);
  }

  export(
    request: ExportPurchaseTransactionRequestDto,
  ): Observable<ApiResponse<ExportListResponse>> {
    return this.reconciliationTransactionService.export(request);
  }
}
